import Card from '@/components/Card';
import PrimarySecondaryLayout from '@/components/PrimarySecondaryLayout';
import Skeleton from '@/components/Skeleton';
import Stack from '@/components/Stack';

const PageSkeleton = () => {
  return (
    <Skeleton.Page media>
      <PrimarySecondaryLayout>
        <PrimarySecondaryLayout.Primary>
          <Stack vertical gap={24}>
            <Card sectioned title="Hired GravyWorkers">
              <Skeleton.Body />
            </Card>
            <Card sectioned title="Direct Invites">
              <Skeleton.Body />
            </Card>
            <Card sectioned title="Timesheets">
              <Skeleton.Body />
            </Card>
          </Stack>
        </PrimarySecondaryLayout.Primary>
        <PrimarySecondaryLayout.Secondary>
          <Stack vertical gap={24}>
            <Card title="Job Details">
              <Card.Section>
                <Skeleton.Body />
              </Card.Section>
              <Card.Section title="Schedule">
                <Skeleton.Body />
              </Card.Section>
              <Card.Section title="Payment">
                <Skeleton.Body />
              </Card.Section>
            </Card>
          </Stack>
        </PrimarySecondaryLayout.Secondary>
      </PrimarySecondaryLayout>
    </Skeleton.Page>
  );
};

export default PageSkeleton;
